import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { endOfMonth, startOfMonth } from 'date-fns'

import { journeyService } from '../services/journeyService'
import {
  GetFunnelParams,
  GetJourneysParams,
} from '../services/journeyService/types'
import { PartnerType } from '../utils/partners.enum'
import { useToast } from '../../view/components/ui/use-toast'

const defaultPeriod = () => ({
  from: startOfMonth(new Date()).toISOString(),
  to: endOfMonth(new Date()).toISOString(),
})

export const useJourneys = (initial?: GetJourneysParams) => {
  const [params, setParams] = useState<GetJourneysParams>({
    ...defaultPeriod(),
    limit: 10,
    skip: 0,
    ...initial,
  })

  const { data, isFetching, isLoading, isError } = useQuery({
    queryKey: ['journeys', params],
    queryFn: () => journeyService.getJourneys(params),
    placeholderData: keepPreviousData,
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregar as jornadas, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return { data, isFetching, isLoading, params, setParams }
}

export const useJourneyFunnel = (params: GetFunnelParams) => {
  const { data, isFetching, isLoading, isError } = useQuery({
    queryKey: ['journeyFunnel', params],
    queryFn: () => journeyService.getFunnel(params),
    placeholderData: keepPreviousData,
    enabled: Boolean(params.product),
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregar o funil, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return { data, isFetching, isLoading }
}

export const useJourneyDetails = (journeyId?: string) => {
  const { data, isFetching, isLoading } = useQuery({
    queryKey: ['journeyDetails', journeyId],
    queryFn: () => journeyService.getJourneyById(journeyId as string),
    enabled: Boolean(journeyId),
  })

  return { data, isFetching, isLoading }
}

/** produtos já instrumentados — o funil dos demais viria vazio */
export const TRACKED_PRODUCTS: PartnerType[] = [
  PartnerType.FGTS,
  PartnerType.CREFAZ,
  PartnerType.C6,
  PartnerType.PAN,
  PartnerType.CLT,
  PartnerType.CREFAZ_CLT,
  PartnerType.CREFISA,
  PartnerType.CREFISA_INSS,
  PartnerType.SALVCAR,
]
